import { useNavigate } from 'react-router';
import styles from './HeaderTitle.module.scss';
import { BiChevronRight } from 'react-icons/bi';


type Props = {
    navTitle?: string;
    navlink?: string;
    headerTitle: React.ReactNode | string;
    isNav: boolean;
    headerExtra?: React.ReactNode;
}

const HeaderTitle = ({ navTitle, navlink, isNav, headerTitle, headerExtra = <></> }: Props) => {
    const navigate = useNavigate();

    return (
        <>
            {isNav ?
                <div className={styles.navContainer}>
                    <div className={styles.navTitle} onClick={() => {
                        navigate(navlink)
                    }}>
                        {navTitle}
                    </div>
                    <div className={styles.navIcon}>
                        <BiChevronRight />
                    </div>
                </div>
                : null
            }
            <div className={styles.headerContainer}>
                <div className={styles.headerTitle}>
                    {headerTitle}
                </div>
                {headerExtra ? headerExtra : null}
            </div>
        </>
    );
}

export default HeaderTitle;